/**
 * Computes whole months remaining from an ISO contract expiry date.
 * @module features/squad-planning/utils/computeContractMonths
 */

/** Average days per month for approximation. */
const DAYS_PER_MONTH = 30.44;

/**
 * Computes whole months remaining from an ISO expiry date.
 * @param expiryDate - ISO date string or null
 * @returns Months remaining (floored), or null if no date
 */
export function computeContractMonths(
  expiryDate: string | null
): number | null {
  if (expiryDate == null) return null;
  const now = new Date();
  const expiry = new Date(expiryDate);
  const diffMs = expiry.getTime() - now.getTime();
  if (diffMs <= 0) return 0;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24 * DAYS_PER_MONTH));
}
